export default __webpack_public_path__ + "static/media/volunteer-network.5f429cb1.png";